import { styled } from 'styled-components'

import { FormattedMessage } from '@b-stock/fe-core/bstock-react'
import { Colors, Typography } from '@b-stock/fe-core/design-system'

import {
  Card,
  CardBody,
} from '@/buyer-portal/components/layouts/CardLayout/card/ui'

import { SimilarListingsButton } from './SimilarListingsButton'
import type { SimilarListingsProps } from './useSearchSimilarListingsHandler'

const Body = styled(CardBody)`
  align-items: flex-start;
  background-color: ${Colors.Semantic.Neutral.light_grey};
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`

const Text = styled.p`
  ${Typography.Subtitle2}
  color: ${Colors.Semantic.Neutral.black};
  margin: 0;
`

/**
 * Search similar listings card for LDP V2.
 */
export const SimilarListingsCard = ({
  categories,
  condition,
  promoteOtherListings,
  searchQuery,
  storefront,
}: Pick<
  SimilarListingsProps,
  | 'categories'
  | 'condition'
  | 'promoteOtherListings'
  | 'searchQuery'
  | 'storefront'
>) => (
  <Card data-testid="search-similar-listings-card">
    <Body $variant="sidebar">
      <Text>
        <FormattedMessage id="Listing.searchSimilar.notQuite" />
      </Text>
      <SimilarListingsButton
        categories={categories}
        condition={condition}
        promoteOtherListings={promoteOtherListings}
        searchQuery={searchQuery}
        storefront={storefront}
        variant="card"
      />
    </Body>
  </Card>
)
